export default __webpack_public_path__ + "static/media/logo_gray.9c2da87a.svg";